import React from 'react';
import { Button, ButtonGroup, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { PlatformType } from '../types';

interface PlatformSelectorProps {
  activeView: PlatformType;
  onPlatformChange: (platform: PlatformType) => void;
}

const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  activeView,
  onPlatformChange
}) => {
  const agentSections = [
    {
      header: (
        <div className="flex actr g10 min-h2">
          <FormattedMessage id="mdm.settings.Apple" />
        </div>
      ),
      icon: 'Apple',
      key: 'IOS' as PlatformType
    },
    {
      header: (
        <div className="flex actr g10 min-h2">
          <FormattedMessage id="mdm.settings.Android" />
        </div>
      ),
      icon: 'Android',
      key: 'ANDROID' as PlatformType
    }
  ];

  return (
    <ButtonGroup segmented>
      {agentSections?.map((section) => (
        <Button
          key={section.key}
          icon={<SVGIcon name={section?.icon || 'About'} size="sm" />}
          onClick={() => onPlatformChange(section?.key)}
          outline={activeView === section?.key}
        >
          <TextStyle>{section?.header}</TextStyle>
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default PlatformSelector;
